export default "__VITE_ASSET__pRq6XWj5__"